import React from 'react';
import { Button, Tooltip } from 'antd';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { darcula } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import { CopyOutlined } from '@ant-design/icons';

interface CodeBlockProps {
  language: string;
  code: string;
}

const CodeBlock: React.FC<CodeBlockProps> = (props: CodeBlockProps) => {
  return (
    <div style={{ position: 'relative' }}>
      <SyntaxHighlighter
        language={props.language}
        style={darcula}
        wrapLongLines={true}
      >
        {props.code}
      </SyntaxHighlighter>
      <Tooltip title="Copied!" trigger="click" placement="top">
        <Button
          style={{
            position: 'absolute',
            top: '2px',
            right: '2px'
          }}
          icon={<CopyOutlined />}
          onClick={() => navigator.clipboard.writeText(props.code)}
        ></Button>
      </Tooltip>
    </div>
  );
};

export default CodeBlock;
